import * as Messages from '../../constants/User/Messages'

const initialState = {
  selectedMessages: null,
  chatRooms: null,
  chatRoomsLoaded: false,
  messagesPartner: null
}
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Messages.GET_MESSAGE_ROOM_INDEX:
      return state;
    case Messages.GET_MESSAGES_RESULT:
      if (action.response === false) {
        return Object.assign({}, state, {
          selectedMessages: null
        })
      } else {
        return Object.assign({}, state, {
          selectedMessages: action.response.chats,
          messagesPartner: action.response.partner
        })
      }
    case Messages.GET_MESSAGES_RESET:
      return Object.assign({}, state, {
        selectedMessages: null,
        messagesPartner: null
      })
    case Messages.GET_MESSAGE_ROOM_RESET:
      return Object.assign({}, state, {
        chatRooms: null,
        chatRoomsLoaded: false
      })
    case Messages.GET_MESSAGE_ROOM_INDEX_RESULT:
      if (action.result === false) {
        return Object.assign({}, state, {
          chatRooms: null,
          chatRoomsLoaded: true
        })
      } else {
        return Object.assign({}, state, {
          chatRooms: action.result,
          chatRoomsLoaded: true
        })
      }
    
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/User/Messages.js